import { Guid } from '.';

export interface DealExcludedLender extends BaseLender {
	guid: Guid;
	isIncumbentLender: boolean;
}

export interface DealReducedFeeLender extends BaseLender {
	guid: Guid;
}

export interface BaseLender {
	dealGuid: Guid;
	bankGuid: Guid;
	bankName: string;
}

export function getExlcudedLenderBase(lender: DealExcludedLender): BaseLender {
	return {
		dealGuid: lender.dealGuid,
		bankGuid: lender.bankGuid,
		bankName: lender.bankName,
	} as BaseLender;
}

export function getExlcudedLendersBase(lenders: DealExcludedLender[] | undefined): BaseLender[] {
	let records = [] as BaseLender[];

	if (lenders && lenders.length > 0) {
		lenders.forEach(lender => {
			records.push(getExlcudedLenderBase(lender));
		});
	}

	return records;
}

export function getReducedFeeLenderBase(lender: DealReducedFeeLender): BaseLender {
	return {
		dealGuid: lender.dealGuid,
		bankGuid: lender.bankGuid,
		bankName: lender.bankName,
	} as BaseLender;
}

export function getReducedFeeLendersBase(lenders: DealReducedFeeLender[] | undefined): BaseLender[] {
	let records = [] as BaseLender[];

	if (lenders && lenders.length > 0) {
		lenders.forEach(lender => {
			records.push(getReducedFeeLenderBase(lender));
		});
	}

	return records;
}
